import note from './clipboard.svg';

export default { note }